export class Configuration {
  static readonly PAGINATOR_OPTIONS = [10, 15, 25, 50, 100];
  static readonly PAGINATOR_DEFAULT = 10;
}
